import React from 'react';
import Styles from '../../../../../stylesheet/css/header-builder/icons/phone.css';
import stylesDevice from '../../../../../stylesheet/css/header-builder/devices-link.css';

const Phone = (props) => (
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="10px" height="17px" viewBox="0 0 10 17" xmlSpace="preserve" fill="#a6a6a6">
    <path className={`st0 ${stylesDevice.svgPath}`} d="M8,0H2C0.9,0,0,0.9,0,2v13c0,1.1,0.9,2,2,2h6c1.1,0,2-0.9,2-2V2C10,0.9,9.1,0,8,0z M6.2,14.4 c-0.5,0.7-1.4,0.8-2.1,0.3c-0.7-0.5-0.8-1.4-0.3-2.1c0.5-0.7,1.4-0.8,2.1-0.3C6.5,12.8,6.7,13.7,6.2,14.4z"/>
  </svg>
);

export default Phone;


// WEBPACK FOOTER //
// ./app/header-builder/components/icons/Phone.js